import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types'
import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import { handleRequest } from '../../../utils/httpRequest';
import { getEndpointUrl } from '../../../utils/endPoints';
import Form from '../../2_Molecules/Form/Form';
import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import parse from 'html-react-parser';
import Modal from '../../2_Molecules/Modal/Modal';

function SaveBuildModal({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState(null);
  const [isModalClosed, setIsModalClosed] = useState(false);

  const { language } = formExtraParams

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    buildname: '',
    optin: false,
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    buildname: ['required'],
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        // TODO: Complete here when the BE api is ready.
        // const endPointUrl = getEndpointUrl('');
        // const res = await handleRequest('post', endPointUrl, data});
        // if (res.Success) {
        setIsSubmitted(true);
        setData(initState)
        // } else {
        //   setFormError(res.state ? res.state : res.Errors[0])
        // }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { firstname, lastname, email, buildname, optin } = data;

  return (
    <Modal
      className="mz-save-build-modal mz-modal-form"
      id="mz-react-save-build-modal"
      isOpen={!isModalClosed && isSubmitted}
      // isOpen={true}
    >
      <FormContainer
        className="mz-save-build"
        isSubmitted={isSubmitted}
        heading={(
          <Fragment>
            <h3>{languageController.getCopy('saveBuild', 'heading')}</h3>
            <p>{languageController.getCopy('saveBuild', 'subHeading')}</p>
          </Fragment>
        )}
        confirmation={(
          <FormConfirmation
            heading={languageController.getCopy('saveBuild', 'confirmationHeading')}
            subHeading={languageController.getCopy('saveBuild', 'confirmationSubHeading')}
            buttonLabel={languageController.getCopy('saveBuild', 'confirmationSubmit')}
            onClick={() => setIsModalClosed(true)}
          />
        )}
        disclaimer={(
          <Checkbox
            name="optin"
            checked={optin}
            onChange={(e) => setData({ ...data, optin: !optin })}
            label={parse(languageController.getCopy('global', 'subscribeLegal'))}
          />
        )}
      >
        <Form
          onSubmit={handleSubmit}
          isDark={false}
          noValidate={true}
          errorMessage={formError}
        >
          <FormGroup md={2}>
            <Input
              type="text"
              name="firstname"
              label={languageController.getFormCopy('label', 'firstname')}
              value={firstname}
              isRequired={true}
              errorMessage={errors.firstname}
              onChange={handleChange}
              maxLength={50}
            />
            <Input
              type="text"
              name="lastname"
              label={languageController.getFormCopy('label', 'lastname')}
              value={lastname}
              isRequired={true}
              errorMessage={errors.lastname}
              onChange={handleChange}
              maxLength={50}
            />
          </FormGroup>
          <Input
            type="email"
            name="email"
            label={languageController.getFormCopy('label', 'email')}
            value={email}
            isRequired={true}
            errorMessage={errors.email}
            onChange={handleChange}
            maxLength={320}
          />
          <Input
            type="text"
            name="buildname"
            label={languageController.getFormCopy('label', 'buildName')}
            value={buildname}
            isRequired={true}
            errorMessage={errors.buildname}
            onChange={handleChange}
            maxLength={100}
          />
          <Button
            type="submit"
            className="mz-btn--primary mz-btn--red"
            label={languageController.getCopy('saveBuild', 'submit')}
          />
        </Form>
      </FormContainer>
    </Modal>
  )
}

SaveBuildModal.propTypes = {
  formExtraParams: PropTypes.object
}

export default SaveBuildModal